export class UserAuthType {
    public code?: string;
    public name?: string;
    public description?: string;

    constructor(data?: any) {
        this.code = data?.code;
        this.name = data?.name;
        this.description = data?.description;
    }
}

export class UserAuthLocation {
    public countryName?: string;
    public cityName?: string;
    public continentCode?: string;

    constructor(data?: any) {
        this.countryName = data?.countryName;
        this.cityName = data?.cityName;
        this.continentCode = data?.continentCode;
    }
}

export class UserAuthLog {
    public date?: Date;
    public type: UserAuthType;
    public userEmail?: string;
    public userId?: string;
    public description?: string;
    public clientName?: string;
    public location?: UserAuthLocation;

    constructor(data: any) {
        this.date = data.date ? new Date(data.date) : null;
        this.type = new UserAuthType(data.type);
        this.userEmail = data.userEmail;
        this.userId = data.userId;
        this.description = data.description;
        this.clientName = data.clientName;
        this.location = new UserAuthLocation(data.location);
    }

    static toUserAuthLog(data: any) {
        return new UserAuthLog(data);
    }
}
